import Fetchers from 'core/fetchers';
TeePublic.Fetchers = Fetchers;
